// extracted by mini-css-extract-plugin
export default {"content":"PrivacyPage_content__hAy28","page_title":"PrivacyPage_page_title__cszGT","page_text":"PrivacyPage_page_text__B0e8a"};